import React from "react";
import { Col, Row } from "react-bootstrap";

const LeftRightForm = (props)=>{
    const { left, right,leftCol,rightCol,className } = props
    return(
        <div className="cb-form-div">
            <div className={`col-lg-${leftCol??4} ${className}` }>
                <div className="ba-asset-left">
                    {left}
                </div>
            </div>
                <div  className={`col-lg-${rightCol??8}`} >
                    <div className="ba-asset-right">
                        {right}
                    </div>
                </div>
            </div>
    )
}
export default LeftRightForm;